import httpCommon from "./http-common";

// Get payment method
const getPaymentMethod = (id: number) => {
  return httpCommon.get(`/v1/get/paymentMethod/${id}`);
};

const getPaymentMethodAsAdmin = () => {
  return httpCommon.get("/v1/admin/get/paymentMethod");
};

// Get all payment methods
const getAllPaymentMethods = () => {
  return httpCommon.get(`/v1/get/paymentMethods`);
};

const getAllPaymentMethodsAsAdmin = () => {
  return httpCommon.get("/v1/admin/get/paymentMethods");
};

// Get payment methods by currency
const getAllPaymentMethodsByCurrency = (businessId: number, currency: string) => {
  return httpCommon.get(`/v1/get/paymentMethodsAndCurrency/${businessId}/${currency}`);
};

// Add payment method
const addPaymentMethod = (data: any) => {
  return httpCommon.post("/v1/add/paymentMethod", data);
};

// Update specific payment method
const updateSpecificPaymentMethod = (id: number, data: any) => {
  return httpCommon.put(`/v1/update/specificPaymentMethod/${id}`, data);
};

// Delete payment method
const deletePaymentMethod = (id: number) => {
  return httpCommon.delete(`/v1/delete/paymentMethod/${id}`);
};

const PaymentMethodService = {
  getPaymentMethod,
  getPaymentMethodAsAdmin,
  getAllPaymentMethods,
  getAllPaymentMethodsAsAdmin,
  getAllPaymentMethodsByCurrency,
  addPaymentMethod,
  updateSpecificPaymentMethod,
  deletePaymentMethod
};
export default PaymentMethodService;